import * as actionTypes from '../actionTypes/locale';

export function getLocaleData() {
    return { type: actionTypes.LOAD_LOCALE_CONFIG };
}
